import { useCallback } from "react";
import { useField } from "formik";
import { SharedserviceMelcoModelsAlphabetListItem } from "melco-shared-logic";
import { moveArray } from "../../../helper/moveArray";

export const useFontsSorting = () => {
  const [{ value: fonts }, , { setValue: setFonts, setError }] =
    useField<SharedserviceMelcoModelsAlphabetListItem[]>("alphabet_list");

  const reorderFonts = useCallback(
    (fromIndex: number, toIndex: number) => {
      setFonts(moveArray(fonts, fromIndex, toIndex));

      // reset field error as sorting changes the index positions which could lead to errors being assigned to the wrong field
      setError(undefined);
    },
    [fonts, setFonts, setError]
  );

  const fontsWithKey = (fonts ?? []).map((c) => ({ ...c, key: c.id! }));

  return [fontsWithKey, reorderFonts] as const;
};
